import req from "../http";

const localization = {
  // 取得 語系
  getLocalizationType(params) {
    return req("get", "/BasicInformation/GetLocalizationType", params);
  },

  // 新增 語系
  postLocalizationType(params) {
    return req("post", "/BasicInformation/AddLocalizationType", params);
  },

  // 更新 語系
  putLocalizationType(params) {
    return req("put", "/BasicInformation/UpdateLocalizationType", params);
  },

  // 排序 語系
  sortLocalizationType(params) {
    return req("put", "/BasicInformation/SortLocalizationType", params);
  }
};

export default localization;